import { Box } from "@mui/material";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import visaeroImg from "../../assets/dashboard/header icon.svg";
import checkImg from "../../assets/Registration/bd74bd2a9be392ce416f720c99db304a.gif";
import style from "./successRegistration.module.css";

export default function SuccessRegistration() {
  const navigate = useNavigate();
  useEffect(() => {
    setTimeout(() => {
    navigate("/add-to-home")
    }, 4000);
  }, []);
  return (
    <Box
      style={{
        position: "fixed",
        display: "grid",
        justifyContain: "center",
        alignItems: "center",
        width:'100svw',
        height:'100svh',
        backgroundColor:'red'
      }}
    >
      <Box className={style.header_container_withLogo}>
        <img src={visaeroImg} className={style.success_img} />
      </Box>
      <Box className={style.success_container}>
        <Box
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "2rem",
            position: "absolute",
            top: "20%",
            alignItems: 'center'
          }}
        >
          <img src={checkImg} alt="success icon" />
          <h4>Fabulous! </h4>
          <h5>Thank you for registering as a VisaLancer</h5>
        </Box>
      </Box>
    </Box>
  );
}
